import _ from 'lodash';
import { BroadcastChannel } from 'broadcast-channel';
import { persistentStorage, PersistentStorageKeys } from '@/utils/persistentStorage';

const BROADCAST_CHANNEL = 'chromatograms-compare';
type OnChange = (ids: number[] | null) => void;

export default class ChromatogramsCompare {
  private static channel = new BroadcastChannel(BROADCAST_CHANNEL);
  private static listeners = new Set<OnChange>();

  static getChannel() {
    return ChromatogramsCompare.channel;
  }

  static isCompared(id) {
    return ChromatogramsCompare.getIDs()?.includes(id);
  }

  static add(id) {
    const ids = _.union(ChromatogramsCompare.getIDs() || [], [id]);
    ChromatogramsCompare.save(ids);
  }

  static remove(id) {
    const ids = (ChromatogramsCompare.getIDs() || []).filter(
      (measurementId) => measurementId !== id,
    );
    ChromatogramsCompare.save(ids);
  }

  static subscribe(onchange) {
    ChromatogramsCompare.listeners.add(onchange);
    ChromatogramsCompare.getChannel().addEventListener('message', onchange);
  }

  static unsubscribe(onchange) {
    ChromatogramsCompare.listeners.delete(onchange);
    ChromatogramsCompare.getChannel().removeEventListener('message', onchange);
  }

  static getIDs() {
    return persistentStorage.get(PersistentStorageKeys.CHROMATOGRAMS_COMPARE_IDS);
  }

  static save(ids) {
    persistentStorage.set(PersistentStorageKeys.CHROMATOGRAMS_COMPARE_IDS, ids);
    ChromatogramsCompare.listeners.forEach((listener) => listener(ids));
    ChromatogramsCompare.getChannel().postMessage(ids);
  }
}
